import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { numberWithCommas } from "../../utility/commonHelpers";
const mapStateToProps = (state) => ({
  metrcisInfo: state.dashboardInfo.metrcisInfo,
});

const DashboardMetrics = (props) => {
  const {
    totalPersistentCredits,
    availablePersistentCredits,
    todayConsumedCredits,
    todayAvailableCredits,
    totalVerified,
    totalValid,
    totalInvalid,
    totalUnknownScored,
    totalUnknown,
  } = props.metrcisInfo;

  // console.log("props.metrcisInfo", props.metrcisInfo);
  // console.log(props.metrcisInfo.availablePersistentcredits);
  return (
    // <div className="right_col" role="main">
    <div className="row top_tiles">
      <div className="animated flipInY col-lg-4 col-md-4 col-sm-6 col-xs-12">
        <div className="tile-stats">
          <div className="icon">
            <i className="fa fa-th" />
          </div>
          <div className="count">{numberWithCommas(availablePersistentCredits)}</div>
          <h3 style={{marginBottom:5}}>One Time Credits Available</h3>
          <p style={{paddingBottom:17}}>Valid for One Year</p>
          {/* <p>&nbsp;</p> */}
        </div>
      </div>
      <div className="animated flipInY col-lg-4 col-md-4 col-sm-6 col-xs-12">
        <div className="tile-stats">
          <div className="icon">
            <i className="fa fa-hourglass-half" />
          </div>
          <div className="count">
            {numberWithCommas(todayAvailableCredits-todayConsumedCredits)}/{numberWithCommas(todayAvailableCredits)}
          </div>
          <h3 style={{marginBottom:5}}> Today's Credits Available</h3>
          <p style={{paddingBottom:17}}>Your daily credits</p>
          {/* <p>&nbsp;</p> */}
        </div>
      </div>
      <div className="animated flipInY col-lg-4 col-md-4 col-sm-6 col-xs-12">
        <div className="tile-stats">
          <div className="icon">
            <i className="fa fa-check-circle" />
          </div>
          <div className="count">{numberWithCommas(totalVerified)}</div>
          <h3 style={{marginBottom:5}}>Verifications to date</h3>
          <p style={{height:34}}>
            <span>{numberWithCommas(totalValid)} Valid</span> |<span> {numberWithCommas(totalInvalid)} Invalid</span> |
            <span> {numberWithCommas(totalUnknownScored)} Unknown Scored</span> |
            <span> {numberWithCommas(totalUnknown)} Unknown</span>
          </p>
        </div>
      </div>
    </div>
  );
  // </div>

  DashboardMetrics.propTypes = {
    totalPersistentCredits: PropTypes.string,
    availablePersistentCredits: PropTypes.string,
    todayConsumedCredits: PropTypes.string,
    todayAvailableCredits: PropTypes.string,
    totalVerified: PropTypes.string,
    totalValid: PropTypes.string,
    totalInvalid: PropTypes.string,
  };
};

export default connect(mapStateToProps)(DashboardMetrics);



// WEBPACK FOOTER //
// ./src/components/Dashboard/DashboardMetrics.js